import moment from 'moment';
// const today = moment('8:00 am', 'h:mm a')

const blankAssignment = (startDate) => {
  const dayString = moment(startDate).format('YYYY-MM-DD') + ' ';

  return {
    itemType: "assignment",
    title: 'Assignment Details',
    assignmentStartTime: null, // moment(dayString + '8:00 am', 'YYYY-MM-DD hh:mm a'),
    assignmentEndTime: null, // moment(dayString + '4:00 pm', 'YYYY-MM-DD hh:mm a'),
    descriptionComment: null,
  }
};

export default blankAssignment;



// WEBPACK FOOTER //
// ./src/Components/Schedule/utils/live-schedules/blankAssignment.js